import { ReactComponent as LockIcon } from "../../../assets/icons/lock.svg";
import { TooltipView } from "../../../components/Tooltip";

export function LockWithTooltip() {
    return (
        <div className="flex items-center gap-1">
            <TooltipView content="Available after 1 Game Mode session is completed" id="lock-with-tooltip" icon={<LockIcon />} className="shadow-[0_10px_30px_0_rgba(0,0,0,0.30)] !border-0 !bg-[linear-gradient(0deg,_rgba(255,255,255,0.60)_0%,_rgba(255,255,255,0.60)_100%),_rgba(255,255,255,0.34)]" />
        </div>
    )
}